import React from "react";
import { Modal } from "bootstrap";
import AppBaseComponent from "../../../components/AppBaseComponent";
import tapIcon from "../../../services/TapIcon";
import { connect } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { Link } from "react-router-dom";
import download from "../../../services/DownloadFile";
import { toast } from "react-toastify";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import api from "../../../services/api";

class BulkFamilyUpload extends AppBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      familyBulkUploadFormSubmitting: false,
    };

    this.emp_family_download_sample_url = HRM_API_BASE_URL_2 + '/employee_family_download_sample';
    this.emp_family_add_by_excel = HRM_API_BASE_URL_2 + '/employee_family_add_by_excel';

  }

  componentDidMount() {
    this.familyBulkUploadModal = new Modal(
      document.getElementById("familyBulkUploadModal"),
      { keyboard: false, backdrop: false }
    );
  }

  modalHandle = () => {
    this.familyBulkUploadModal.show();
  };

  downloadSampleFile = () => {
    HttpAPICall.withAthorization("GET", this.emp_family_download_sample_url, this.props.access_token, {}, {}, (response) => {
        download.file(response.data.file_path);
        toast.success(
          "Employee Family Sample Excel File Downloaded Successfully",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        this.familyBulkUploadModal.hide();
      }
    );
  };

  formSubmit = (e) => {
    e.preventDefault();
    this.setState({
      familyBulkUploadFormSubmitting: true,
    });
    const data = new FormData(document.getElementById("familyBulkUploadForm"));
   let headers = { 'Authorization': 'Bearer ' + this.props.access_token, };
           api.server2Api
      .post(this.emp_family_add_by_excel, data, {
        headers: headers,
      })
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        this.familyBulkUploadModal.hide();
        //Load Add Item Form Data :-
        download.file(response.data.generated_file.file_path);
        setTimeout(() => {
          this.props.loadListingTblData();
        }, 1000);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ?? "Unable to upload Family Add File.",
          { position: toast.POSITION.TOP_RIGHT }
        );
      })
      .then(() => {
        this.setState({ familyBulkUploadFormSubmitting: false });
      });
  };

  render() {
    return (
      <div className="modal fade" id="familyBulkUploadModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="familyBulkUploadModalLabel">
                Bulk Family Upload
              </h5>
              <button
                type="button"
                disabled={this.state.familyBulkUploadFormSubmitting}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form
              onSubmit={this.formSubmit}
              id="familyBulkUploadForm"
              method="post"
              encType="multipart/form-data"
            >
              <div className="modal-body">
                <div className="row align-items-center mb-3 mt-3">
                  <div className="col-12">
                    <input
                      name="document"
                      type="file"
                      className="form-control"
                      required={true}
                    />
                  </div>
                  <div className="col-12 mt-2 form-text">
                    # Excel Sheet with Extention xls,xlm,xlsx,ods Allowed
                  </div>
                  <div className="col-12 mt-2 form-text">
                    # Miximum 100 MB Size of Excel Sheet Allowed
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <Link
                    type="button"
                    className="float-left"
                    href="#"
                    onClick={this.downloadSampleFile}
                  >
                    Download Sample File
                  </Link>
                </div>
                <div>
                  <button
                    type="button"
                    disabled={this.state.familyBulkUploadFormSubmitting}
                    className="btn btn-secondary mx-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={this.state.familyBulkUploadFormSubmitting}
                    className="btn btn-primary"
                  >
                    Submit{" "}
                    {this.state.familyBulkUploadFormSubmitting ? (
                      <tapIcon.FontAwesomeIcon
                        icon={tapIcon.faSyncAlt}
                        className="fa-spin"
                      />
                    ) : (
                      ""
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access_token: state.auth.access_token,
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  BulkFamilyUpload
);
